require('./bootstrap');

// Import modules...
import {createApp, h} from 'vue';
import {App as InertiaApp, plugin as InertiaPlugin} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import VueToast from 'vue-toast-notification';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';


const el = document.getElementById('app');

createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})
    .mixin({
        methods: {
            route,
            capitalize: str => str.charAt(0).toUpperCase() + str.toLowerCase().slice(1),
            convertDate: date => {
                var date = new Date(date);
                return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
            },
            convertMonthYear: date => {
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var date = new Date(date);
                return monthNames[date.getMonth()] + ' ' + date.getFullYear()
            },
            convertDateTime: date => {
                var date = new Date(date);
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + strTime;
            },
            titleCase: str => str.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase())
            ,

        }
    })
    .use(InertiaPlugin)
    .use(VueToast)
    .use(VCalendar, {})
    .mount(el);

InertiaProgress.init({color: '#4B5563'});
